import React, { useCallback, useEffect, useState } from "react";
import { buildPdfIframeSrc } from "../../../utils/exportPdfPreview.js";
import { shouldPreferPdfEmbed } from "../../../utils/pdfEmbedMode.js";

/**
 * PDF im Modal: Mobile per <embed>, Desktop per iframe (Toolbar per CSS ausgeblendet).
 */
export default function PdfInlinePreview({
  src = "",
  title = "PDF-Vorschau",
  preferEmbed = false,
  onFailed = null,
}) {
  const safeSrc = String(src || "").trim();
  const wantEmbed = shouldPreferPdfEmbed(safeSrc, { mobileLike: preferEmbed });
  const [mode, setMode] = useState(wantEmbed ? "embed" : "iframe");

  useEffect(() => {
    setMode(wantEmbed ? "embed" : "iframe");
  }, [wantEmbed, safeSrc]);

  const handleFail = useCallback(() => {
    if (mode === "iframe") {
      setMode("embed");
      return;
    }
    onFailed?.();
  }, [mode, onFailed]);

  if (!safeSrc) return null;

  const embedSrc = safeSrc;

  if (mode === "embed") {
    return (
      <embed
        src={embedSrc}
        type="application/pdf"
        title={title}
        className="pdf-embed-frame pdf-embed-native w-full border-0"
        data-testid="pdf-embed-element"
        onError={handleFail}
      />
    );
  }

  return (
    <iframe
      src={buildPdfIframeSrc(safeSrc)}
      title={title}
      className="pdf-embed-frame w-full border-0"
      data-testid="pdf-embed-iframe"
      onError={handleFail}
    />
  );
}
